import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AUTO_STYLE, keyframes, style } from '@angular/animations';

import { NgStaticAnimationService } from '../../shared/services/static-animation.service';
import { EnumNgEventName } from '../../shared/event-animation.data';
import { INgAnimationStates, INgEffectOptions, INgAnimationTiming } from '../../shared/event-animation.interface';


/**------------------------------------------------------
 * Animation State Definitions
 */
const NG_ANIMATION_STATES: INgAnimationStates = {
	start 	: keyframes([
		style({ visibility: AUTO_STYLE, 'box-shadow': '0 10px 10px -10px #00000080', 'transform': 'scale(1.1)', easing: 'ease', offset: 0 }),
		style({ 'box-shadow': 'none', 'transform': 'scale(1)', easing: 'ease', offset: 1 })
	]),
	end 	: keyframes([
		style({ visibility: AUTO_STYLE, 'box-shadow': 'none', easing: 'ease', offset: 0 }),
		style({ 'box-shadow': '0 10px 10px -10px #00000080', 'transform': 'scale(1.1)', easing: 'ease', offset: 1 })
	])
};


/**------------------------------------------------------
 * GrowShadow on Event
 */
@Directive({
    selector: '[ngGrowShadowOnEvent]',
    providers: [NgStaticAnimationService],
    standalone: false
})
export class NgGrowShadowOnEventDirective implements OnInit {

	//** Input Decorators */
	@Input('ngGrowShadowOnEvent') effectOptions: Partial<INgEffectOptions> = null!;
	@Input() targetElement: HTMLElement = null!;

	constructor(
		private elementRef				: ElementRef,
		private staticAnimationService 	: NgStaticAnimationService
	) {}

	//** Setup the Animation */
	ngOnInit(): void {
		this.staticAnimationService.setupAnimation({
			triggerElement	: this.elementRef.nativeElement,
			targetElement	: this.targetElement,
			states			: NG_ANIMATION_STATES,
			event			: this.effectOptions?.event!,
			timing			: {
				duration	: this.effectOptions?.duration,
				delay		: this.effectOptions?.delay
			}
		});
	}
}


/**------------------------------------------------------
 * GrowShadow on Mouse Hover
 */
@Directive({
    selector: '[ngGrowShadowOnMouseHover]',
    providers: [NgStaticAnimationService],
    standalone: false
})
export class NgGrowShadowOnMouseHoverDirective implements OnInit {

	//** Input Decorators */
	@Input('ngGrowShadowOnMouseHover') timingOptions: Partial<INgAnimationTiming> = null!;
	@Input() targetElement: HTMLElement = null!;

	constructor(
		private elementRef				: ElementRef,
		private staticAnimationService 	: NgStaticAnimationService
	) {}

	//** Setup the Animation */
	ngOnInit(): void {
		this.staticAnimationService.setupAnimation({
			triggerElement	: this.elementRef.nativeElement,
			targetElement	: this.targetElement,
			states			: NG_ANIMATION_STATES,
			event			: EnumNgEventName.MouseHover,
			timing			: this.timingOptions
		});
	}
}
